export function LoadingWrapper({ loading, children }) {
  return (
    <>
      {loading && <span className="ui active centered inline loader" />}
      {!loading && children}
    </>
  );
}

export function Loading({ loading }: { loading: boolean }) {
  return loading && <span className="ui active centered inline loader" />;
}
